// @flow

import * as React from 'react';

import s from './ProgressBar.scss';

type Props = {
  show: boolean,
  amount: number,
}

export const ProgressBar = (props: Props) => {
  const { show, amount } = props;

  return (
    <div
      className={s.upload_container}
      style={{display: show ? 'block' : 'none'}}
    >
      <div
        className={s.filler}
        style={{transform: `translate(${amount - 100}%, -60%) rotate(40deg)`}}
      ></div>
    </div>
  )
}



export default ProgressBar;
